import type { FC } from "react";

import type { Language } from "@ui/components/LanguageSelector";
import classNames from "classnames";

import styles from "./LanguageSelectorListItem.module.scss";

type LanguageSelectorListItemProps = {
  language: Language;
  selectedLanguageCode?: string;
  onSelectLanguage: (language: Language) => void;
};

export const LanguageSelectorListItem: FC<LanguageSelectorListItemProps> = ({
  language,
  selectedLanguageCode,
  onSelectLanguage,
}) => {
  const isItemActive = language.associatedCookieValue === selectedLanguageCode;

  const handleSelectLanguage = () => {
    onSelectLanguage(language);
  };

  return (
    <li className={classNames(styles.listItem, { [styles.listItemActive]: isItemActive })}>
      <button
        type="button"
        data-testid="languageSelectorLangBtn"
        className={classNames(styles.listItemBtn, {
          [styles.listItemBtnActive]: isItemActive,
        })}
        onClick={handleSelectLanguage}
      >
        {language.languageDisplayName}
      </button>
    </li>
  );
};
